module.exports = __webpack_public_path__ + "tables/media/Maps_outlined.a72cf395.svg";